var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg19299514501540882611(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.285 11.284L16 19.571l-8.285-8.288a1.01 1.01 0 10-1.429 1.43l8.999 9.002a1.009 1.009 0 001.428 0l8.999-9.002a1.01 1.01 0 10-1.427-1.429z",
    fill: "#121313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19299514501540882611);
export default __webpack_public_path__ + "static/media/19299514501540882611.4bd07d25531bc1a47bc09c84ceab2a35.svg";
export { ForwardRef as ReactComponent };